module.exports = "<div id=\"login-logo\" class=\"card\">\n\t<img src=\"" + require("../../../img/letang_logo.svg") + "\" alt=\"\">\n</div>\n";